import React from 'react'
import PropTypes from 'prop-types'
import { styled } from '@creditas/stylitas'

import { Footer } from './Footer'
import { Navbar } from './Navbar'

const Wrapper = styled.div`
  width: 100%;
  position: relative;
  min-height: 100vh;
  padding-bottom: 56px;
`

const propTypes = {
  children: PropTypes.node,
}

const MainWrapper = ({ children, useNewNavbar = false, ...rest }) => {
  return (
    <Wrapper {...rest}>
      <Navbar useNewNavbar={useNewNavbar} />
      <div>{children}</div>
      <Footer />
    </Wrapper>
  )
}

MainWrapper.propTypes = propTypes

export { MainWrapper }
